(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.scarpeMotionInitialized) return;
  window.scarpeMotionInitialized = true;
  const initialize = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videos = new Set();
    const seen = new WeakSet();
    const optimizeThumbnail = image => {
      const item = image.closest('[data-target]');
      if (!item) return;
      const target = item.getAttribute('data-target');
      const video = document.querySelector('.product__media-item[data-media-id="' + CSS.escape(target) + '"] video.scarpe-product-motion');
      if (!video || !video.poster) return;
      const url = video.poster + '&width=416';
      if (image.src === url) return;
      image.src = url;
      image.srcset = video.poster + '&width=162 162w, ' + video.poster + '&width=324 324w, ' + url + ' 416w';
    };
    const activate = video => {
      if (!video.src) {
        video.src = video.dataset.scarpeMotionSrc;
        video.muted = true;
        video.load();
      }
      if (!reduced.matches && !document.hidden) video.play().catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.dataset.scarpeMotionVisible = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting) activate(entry.target);
          else entry.target.pause();
        });
      }, { threshold: 0.15 });
      const bind = video => {
        if (seen.has(video)) return;
        seen.add(video);
        videos.add(video);
        observer.observe(video);
      };
      document.querySelectorAll('video.scarpe-product-motion').forEach(bind);
      document.querySelectorAll('[data-target] img').forEach(optimizeThumbnail);
      new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'attributes') { optimizeThumbnail(record.target); return; }
          record.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches('video.scarpe-product-motion')) bind(node);
          node.querySelectorAll('video.scarpe-product-motion').forEach(bind);
          if (node.tagName === 'IMG') optimizeThumbnail(node);
          node.querySelectorAll('img').forEach(optimizeThumbnail);
        });
        });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    } else {
      document.querySelectorAll('video.scarpe-product-motion').forEach(video => { videos.add(video); activate(video); });
    }
    document.addEventListener('visibilitychange', () => {
      videos.forEach(video => {
        if (document.hidden) video.pause();
        else if (video.dataset.scarpeMotionVisible === 'true') activate(video);
      });
    });
    reduced.addEventListener('change', () => {
      videos.forEach(video => {
        if (reduced.matches) video.pause();
        else if (video.dataset.scarpeMotionVisible === 'true') activate(video);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
